// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"de81638e","455":"9474a196","977":"901789fe"}[chunkId] + ".chunk.js";
};